import React, { useLayoutEffect, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Grid, Box, Button } from '@material-ui/core';
import freature01 from '../../assets/images/Sector-Index-Icon.png';
import freature02 from '../../assets/images/Trading-Vaults-Icon.png';
import freature03 from '../../assets/images/Yield-Farming-Icon.png';
import freature04 from '../../assets/images/Earn-xWin-Token-Icon.png';
import './Features.css';
import AOS from 'aos';




function Feaures() {
	useEffect(() => {
		AOS.init({
			disable: 'mobile'
		});
	});

	return (
		<section id="features">
			<Container maxWidth="lg" className="main-container text-white">
				<Grid container spacing={7}>
					<Grid item xs={12}>
						<Box textAlign="center" className="section-heading text-uppercase">
							<h2 data-aos="fade-up" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200">Features Highlight</h2>
						</Box>
					</Grid>
					<Grid data-aos="fade-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" item md={6} xs={12}>
						<Box textAlign="center" className="feature-box">
							<Box textAlign="center" className="feture-icon-holder">
								<img src={freature01} alt="Feature Icon" />
							</Box>
							<Box className="feture-text-holder">
								<h2>SECTOR INDEX</h2>
								<p>Expose to DEFI or sector specific basket of tokens. Add them to your portfolio for diversification.</p>
							</Box>
						</Box>
					</Grid>
					<Grid data-aos="fade-left" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" item md={6} xs={12}>
						<Box textAlign="center" className="feature-box">
							<Box textAlign="center" className="feture-icon-holder">
								<img src={freature02} alt="Feature Icon" />
							</Box>
							<Box className="feture-text-holder">
								<h2>TRADING VAULTS</h2>
								<p>Follow the experts on various trading strategies. Be it technical analysis or fundamental. Enjoy the free rides!</p>
							</Box>
						</Box>
					</Grid>
					<Grid data-aos="fade-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" item md={6} xs={12}>
						<Box textAlign="center" className="feature-box">
							<Box textAlign="center" className="feture-icon-holder">
								<img src={freature03} alt="Feature Icon" />
							</Box>
							<Box className="feture-text-holder">
								<h2>YIELD FARMING VAULT</h2>
								<p>xWin make farming investment easier than ever. It adds BNB into PCS liquidity and farming pool with auto compound utility.</p>
							</Box>
						</Box>
					</Grid>
					<Grid data-aos="fade-left" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" item md={6} xs={12}>
						<Box textAlign="center" className="feature-box">
							<Box textAlign="center" className="feture-icon-holder">
								<img src={freature04} alt="Feature Icon" />
							</Box>
							<Box className="feture-text-holder">
								<h2>EARN xWIN TOKEN</h2>
								<p>Fully utilize XWIN vault token to farm more XWIN. You can trade it in DEX and provide liquidity to Pancakeswap LP.</p>
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12}>
						<Box textAlign="center" className="footer-btns-holder">
							<Button data-aos="fade-right" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" variant="contained" color="primary">Launch the App</Button>
							<Button data-aos="fade-left" data-aos-offset="80" data-aos-duration="600" data-aos-delay="200" variant="contained" color="secondary">xWin Docs</Button>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
}
export default Feaures;